export default __webpack_public_path__ + "static/media/G0425.Glycaemic_freestyle1.1692956460000.e8c33c35.jpg";